import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

import { IAdminCatalogForUpdate } from '../interfaces/IAdminCatalogForUpdate';

export async function fetchCatalogsForUpdate(): Promise<IAdminCatalogForUpdate[]> {
  return apiGet<IAdminCatalogForUpdate[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/external-catalogs`);
}

export async function updateCatalog(id: number, file: File): Promise<void> {
  const formData = new FormData();

  formData.append('file', file);

  return apiPost<void>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/external-catalogs/${id}/file`,
    body: formData,
  });
}
